import ReactGA from "react-ga4";

export default function logPage(location: string) {
    console.log(location);
    switch (location) {
        case "/auth/home":
            ReactGA.send({ hitType: "pageview", page: location, title: "Login Page" })
            break;
        case "/auth/home/reg-user":
            ReactGA.send({ hitType: "pageview", page: location, title: "Register Page" })
            break;
        case "/amp":
            ReactGA.send({ hitType: "pageview", page: location, title: "Home Page" })
            break;
        case "/amp/property":
            ReactGA.send({ hitType: "pageview", page: location, title: "Property Details Page" })
            break;
        case "/amp/property-assessment":
            ReactGA.send({ hitType: "pageview", page: location, title: "How Assessment Works Page" })
            break;
        case "/amp/nbhd":
            ReactGA.send({ hitType: "pageview", page: location, title: "Browse My Neighbourhood Page" })
            break;
        case "/amp/rfr":
            ReactGA.send({ hitType: "pageview", page: location, title: "RFR Page" })
            break;
        case "/amp/profile":
            ReactGA.send({ hitType: "pageview", page: location, title: "Manage My Account Page" })
            break;
        case "/amp/contact-us":
            ReactGA.send({ hitType: "pageview", page: location, title: "Contact Us Page - Authed" })
            break;
        case "/amp/sign-out":
            ReactGA.send({ hitType: "pageview", page: location, title: "Sign Out Page" })
            break;
        case "/auth/contact-us":
            ReactGA.send({ hitType: "pageview", page: location, title: "Contact Us Page - Not Authed" })
            break;
        case "/toc":
            ReactGA.send({ hitType: "pageview", page: location, title: "TOC Page" })
            break;
        case "/pierportal":
            ReactGA.send({ hitType: "pageview", page: location, title: "PIER Portal Page" })
            break;
        
        default:
            break;
    }
}